import { GET_CITIES, GET_SPECIALTIES, GET_MEDICAL_SCHEDULE } from 'store/constants'

export function getCities(values) {
  return {
    type: GET_CITIES,
    payload: values,
  }
}

export function getSpecialties(values) {
  return {
    type: GET_SPECIALTIES,
    payload: values,
  }
}

export function getMedicalSchedule(values) {
  return {
    type: GET_MEDICAL_SCHEDULE,
    payload: values,
  }
}
